/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { CurrentUserService } from '@ews/users-management';
import { environment } from '../environments';

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {
  private language = 'en';
  private userId?: string;

  constructor(
    private readonly translateService: TranslateService,
    private readonly currentUserService: CurrentUserService
  ) {
    this.language = this.translateService.currentLang || 'en';
    this.translateService.onLangChange.subscribe((event) => {
      this.language = event.lang;
    });

    this.currentUserService.user.subscribe((user) => {
      this.userId = user?.id;
    });
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const headers: { [key: string]: string } = {
      'X-NCP-Language': this.language || 'en',
      'X-NCP-Version': environment.version || '',
    };

    if (this.userId) {
      headers['X-NCP-UserId'] = this.userId;
    }

    const modifiedReq = req.clone({
      withCredentials: true,
      setHeaders: headers,
    });

    return next.handle(modifiedReq);
  }
}
